export enum USER_ROLE {
  SUPERADMIN = 'superadmin',
  TELCLOUD_ADMIN = 'telcloud_admin',
  TELCLOUD_USER = 'telcloud_user',
  TELCLOUD_VIEWER = 'telcloud_viewer',
  RESELLER_OWNER = 'reseller_owner',
  RESELLER_ADMIN = 'reseller_admin',
  RESELLER_USER = 'reseller_user',
  RESELLER_VIEWER = 'reseller_viewer',
  CUSTOMER_OWNER = 'customer_owner',
  CUSTOMER_ADMIN = 'customer_admin',
  CUSTOMER_USER = 'customer_user',
  CUSTOMER_VIEWER = 'customer_viewer',
  RESELLER_NOAGREEMENT = 'reseller_noagreement',
}